<template lang="pug">
.col-xs-4
  h5 パーツ一覧
  .part-area.panel-group
    .panel.panel-default(
      v-for='(item, index) in items'
      draggable='true' @dragstart='dragStart'
      :type='item.type')
      .row
        .col-xs-1.icon
          i.fa.fa-item.fa-font(aria-hidden='true' v-show='item.type === `text`')
          i.fa.fa-item.fa-align-justify(aria-hidden='true' v-show='item.type === `textarea`')
          i.fa.fa-item.fa-chevron-circle-down(aria-hidden='true' v-show='item.type === `dropdown`')
          i.fa.fa-item.fa-check-square-o(aria-hidden='true' v-show='item.type === `checkbox`')
          i.fa.fa-item.fa-dot-circle-o(aria-hidden='true' v-show='item.type === `radio`')
          i.fa.fa-item.fa-home(aria-hidden='true' v-show='item.type === `address`')
          i.fa.fa-item.fa-calendar(aria-hidden='true' v-show='item.type === `date`')
          i.fa.fa-item.fa-clipboard(aria-hidden='true' v-show='item.type === `file`')
        .col-xs-11
          h5.panel-title(v-show='item.type === `text`') 1行テキストボックス
          h5.panel-title(v-show='item.type === `textarea`') 複数行テキストボックス
          h5.panel-title(v-show='item.type === `dropdown`') ドロップダウンリスト
          h5.panel-title(v-show='item.type === `checkbox`') チェックボックス
          h5.panel-title(v-show='item.type === `radio`') ラジオボタン
          h5.panel-title(v-show='item.type === `address`') 住所
          h5.panel-title(v-show='item.type === `date`') 日付
          h5.panel-title(v-show='item.type === `file`') ファイル添付
</template>

<script>
import { components } from './PartConfig'
import { bus } from '@/service'

export default {
  data () {
    return {
      items: []
    }
  },
  mounted () {
    this.items = components
  },
  methods: {
    dragStart (e) {
      e.dataTransfer.dropEffect = 'move'
      bus.$emit('partDragStart', e.srcElement.getAttribute('type'))
    }
  }
}

</script>
<style lang="stylus" scoped>
.part-area
  padding: 10px
  border: 1px solid #ddd
  border-radius: 3px
  .row
    margin-right: 0
  h5
    padding: 10px 15px
  .panel.panel-default
    background: #fff
    padding-left: 5px
    cursor: pointer
    margin-top: 0px
    margin-bottom: 5px
  i.fa.fa-arrows
    padding-left: 0px
  .col-xs-1.move
    padding: 0
</style>



// WEBPACK FOOTER //
// ItemSource.vue?8b6c493a